<template>
  <div class="auth-input-wrapper">
    <input :class="{ error: !name.isValid,
          valid: (name.isValid && name.length > 0) }"
      @input="validateWithDebounce"
      @blur="validate"
      v-model="value"
      type="text"
      id="name"
      required
    >
    <label for="name">Imię i nazwisko</label>
    <p class="error" v-if="name.isTooShort">Treść pola jest zbyt krótka!</p>
    <p class="error" v-else-if="name.isTooLong">Treść pola jest zbyt długa!</p>
    <p class="error"
      v-if="!name.isAlphanumeric
      && !name.isTooLong
      && !name.isTooShort"
    >Niepoprawne imię i nazwisko!</p>
  </div>
</template>

<script>
import { validateName, debounce, debounceOffset } from '../authValidation';

export default {
  name: 'NameAuthInput',
  data() {
    return {
      name: {
        isValid: true,
        isTooShort: false,
        isTooLong: false,
        isAlphanumeric: true,
        length: 0
      }
    };
  },
  computed: {
    value: {
      get() {
        return this.$store.getters.registrationName;
      },
      set(value) {
        this.$store.commit('updateRegistrationName', value);
      }
    }
  },
  methods: {
    validateWithDebounce(e) {
      debounce(() => {
        this.$store.dispatch('clearAllAuthErrors');
        this.validate(e);
      }, debounceOffset);
    },
    validate(e) {
      validateName(e, this.name);
      this.$store.commit('updateIsRegistrationNameValid', this.name.isValid);
    }
  }
};
</script>
